module.exports = __webpack_public_path__ + "img/project-climateProtectors copy 2.e5d09316.jpg";